import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map, publishReplay, refCount } from 'rxjs/operators';
import { UrlBuilder } from '../../../core';
import { TabCategory } from '../../../documents';
import { routeData } from '../../../shared/route-helpers';
import { Site } from '../../../sites';

@Component({
    selector: 'investigator-tabs',
    template: require('./investigator-e-query-tabs.component.html'),
    styles: [require('./investigator-e-query-tabs.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvestigatorEQueryTabsComponent {
    public readonly tabs$: Observable<TabCategory[]>;

    constructor(urlBuilder: UrlBuilder, route: ActivatedRoute) {
        const site$ = route.parent.data.pipe(map(d => d[routeData.selectedSite] as Site));
        this.tabs$ = site$.pipe(
            map(site => {
                const tabs: TabCategory[] = [];

                const awaitingResponse = urlBuilder
                    .esa()
                    .site(site)
                    .eQueries()
                    .awaitingResponse()
                    .url();

                tabs.push({ name: 'Awaiting Response', url: awaitingResponse });

                const responseSubmittedUrl = urlBuilder
                    .esa()
                    .site(site)
                    .eQueries()
                    .responseSubmitted()
                    .url();

                tabs.push({ name: 'Response Submitted', url: responseSubmittedUrl });

                return tabs;
            }),
            publishReplay(1),
            refCount(),
        );
    }
}
